import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {IFeatureData} from "../server/IData";
import {Symbol} from "../reels/Symbol";
import { Sound } from "../sound/Sound";

export class KillCountRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.monstersWithNoLife.length > 0 && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const featureTl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            featureData: number[] = Game.model.monstersWithNoLife;

        controller.setSkipCallback(() => {
            this.skip(featureTl);
        });

        if (Game.monsterSymbolsGoingDead && Game.monsterSymbolsGoingDead.length) {
            Game.monsterSymbolsGoingDead.forEach((symbol: Symbol) => {
                featureTl.add(() => {
                    Game.overlaysForSymbols.playBzBreak(symbol);
                }, 0);
                featureTl.to(symbol.animation, {
                    duration: 20 / 30,
                    alpha: 0,
                    onComplete: () => {
                        if (symbol.parent) {
                            symbol.parent.removeChild(symbol);
                        }
                    }
                }, 0);
            });
            featureTl.add(() => {
                Game.monsterSymbolsGoingDead = [];
            });
        }

        featureData.forEach((value: number) => {
            const symbolsToRemove: IFeatureData[] = Game.getSymbolPosFromReel(Game.ORDINARY_PAYOUT_SYMBOLS[value]);
            Game.soundPlayer.playSound(Sound.LOOT_VANISH, 1);
            symbolsToRemove.forEach((data: IFeatureData) => {
                featureTl.add(Game.removeSymbolFromAReel(data.reelId, data.rowId, false, true, true), 0);
            });
        });
    }

    private skip(featureTl: gsap.core.Timeline): void {
        featureTl.totalProgress(1);
    }
}